/** Shared backend origin for REST and Socket.IO (no trailing slash). */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://172.191.158.85:5000';
